// extracted by mini-css-extract-plugin
export default {"profileItem":"save_as_view_modal-module___profileItem___d5605e75"};